import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import orar from "../../Assets/Projects/orar-usv.png";
import visenna from "../../Assets/Projects/visenna.png";
import foodLens from "../../Assets/Projects/BiteWise/bitewise.png";
// import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import { Helmet } from "react-helmet-async";
// import chatify from "../../Assets/Projects/chatify.png";
// import suicide from "../../Assets/Projects/suicide.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <>
     <Helmet>
      <title>Projects — Cosmin Pascariu</title>
        <meta name="description" content="Selected React and React Native projects with notes on performance, UX and links to code or live demos." />
        <link rel="canonical" href="https://cosminpascariu.comproject" />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cosmin Pascariu" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="Projects — Cosmin Pascariu" />
        <meta property="og:description" content="React & React Native project portfolio with code and demos." />
        <meta property="og:url" content="https://cosminpascariu.comproject" />
        <meta property="og:image" content="https://cosminpascariu.comog/projects-1200x630.jpg" />
        <meta property="og:image:alt" content="Project thumbnails by Cosmin Pascariu" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Projects — Cosmin Pascariu" />
        <meta name="twitter:description" content="React & React Native portfolio." />
        <meta name="twitter:image" content="https://cosminpascariu.comog/projects-1200x630.jpg" />

        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Projects",
          "url": "https://cosminpascariu.comproject",
          "about": { "@id": "https://cosminpascariu.com#me" }
        }
        `}</script>

        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://cosminpascariu.com" },
            { "@type": "ListItem", "position": 2, "name": "Projects", "item": "https://cosminpascariu.comproject" }
          ]
        }
        `}</script>
      </Helmet>
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={orar}
              isBlog={false}
              title="Orar USV"
              description="A centralized web platform designed to simplify class scheduling and access for university students and professors. With over 10,000 active users, it provides real-time updates on class times, locations, and changes — ensuring everyone stays informed and organized throughout the academic year."
              demoLink="https://orar.usv.ro/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={visenna}
              isBlog={false}
              title="Visenna"
              description="Visenna.io is a digital health platform designed to enhance clinic-patient interactions by providing a secure and user-friendly environment for managing and accessing medical documents. It ensures that health records are safely stored and readily available, facilitating seamless communication between patients and healthcare providers."
              demoLink="https://visenna.io/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="YourEnergy"
              description="YourEnergy is a React Native mobile app empowering prosumers and consumers to manage renewable energy seamlessly. It offers real-time monitoring, secure transactions, interactive maps, and customizable pricing, facilitating efficient energy trading and promoting sustainable practices."
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={foodLens}
              isBlog={false}
              title="FoodLens"
              description="FoodLens is an AI-powered mobile application that enables users to scan their meals and receive instant insights into food type, estimated calories, weight, and dimensions. By leveraging advanced computer vision and deep learning algorithms, FoodLens accurately identifies various food items and provides nutritional information, assisting users in making informed dietary choices. Whether you're managing your diet, tracking your nutrition, or simply curious about your meals, FoodLens offers a seamless and informative experience right at your fingertips."
            />
          </Col>
        </Row>
      </Container>
    </Container>
    </>
  );
}

export default Projects;
